import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">常见问题</h2>
        <div className="max-w-4xl mx-auto space-y-3">
          {faqData.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200/50 transition-colors list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-8">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-300/60 flex items-center justify-center group-open:rotate-180 transition-transform duration-200">
                  <i className="ri-arrow-down-s-line text-foreground-600"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}